import { render } from "./view.vue?vue&type=template&id=ca470f84&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"

import "./view.vue?vue&type=style&index=0&id=ca470f84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ca470f84"

export default script